import { Button } from '@goaltree/ui/button'
import { Dialog, DialogContent, DialogHeader, DialogTitle } from '@goaltree/ui/components/dialog'
import { useTranslation } from 'react-i18next'

type ReplanChanges = {
  archivedTasks: string[]
  addedTasks: string[]
  simplifiedMilestones: string[]
  activeMilestoneTitle: string
}

interface ReplanModalProps {
  open: boolean
  onClose: () => void
  onSeeChanges: () => void
  changes: ReplanChanges
  completedMilestones: number
  totalMilestones: number
}

export function ReplanModal({
  open,
  onClose,
  onSeeChanges,
  changes,
  completedMilestones,
  totalMilestones,
}: ReplanModalProps) {
  const { t } = useTranslation()

  return (
    <Dialog open={open} onOpenChange={(o) => !o && onClose()}>
      <DialogContent className="max-w-sm">
        <DialogHeader>
          <DialogTitle>{t('common.replanModalTitle')}</DialogTitle>
        </DialogHeader>
        <p className="text-sm text-muted-foreground">
          {t('common.replanModalDesc', {
            completed: completedMilestones,
            total: totalMilestones,
            plural: totalMilestones !== 1 ? 's' : '',
          })}
        </p>
        <div className="mt-2 space-y-1">
          <p className="text-sm font-medium">{t('common.replanWhatChanged')}</p>
          <ul className="text-sm text-muted-foreground list-disc pl-4 space-y-1">
            {changes.archivedTasks.length > 0 && (
              <li>{t('common.replanArchivedTasks', { count: changes.archivedTasks.length })}</li>
            )}
            {changes.addedTasks.length > 0 && (
              <li>{t('common.replanAddedTasks', { count: changes.addedTasks.length })}</li>
            )}
            {changes.simplifiedMilestones.map((ms) => (
              <li key={ms}>{t('common.replanSimplified', { title: ms })}</li>
            ))}
          </ul>
        </div>
        <div className="flex gap-2 mt-4">
          <Button variant="outline" onPress={onSeeChanges} className="cursor-pointer flex-1">
            {t('common.replanSeeChanges')}
          </Button>
          <Button onPress={onClose} className="cursor-pointer flex-1">
            {t('common.replanKeepGoing')}
          </Button>
        </div>
      </DialogContent>
    </Dialog>
  )
}
